import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import seo from '../../seo/seoConfig.json';
import landingPages from '../../content/landingPages.json';
import bikeCollections from '../../content/bikeCollections.json';

const PageTitleUpdater = () => {
    const location = useLocation();

    useEffect(() => {
        const path = location.pathname.replace(/\/+$/, '') || '/';
        let title = 'PROOMTB & ROAD | Tu tienda de bicicletas';

        // Product and blog pages set their own title with Helmet
        if (path.startsWith('/product/') || path.startsWith('/blog') || path.startsWith('/navidad') || /^\/(tienda|search|ebikes|accesorios|catalogo|bicicletas-analogas|category\/|bicicletas\/)/.test(path)) return;

        if (landingPages[path]) {
            title = landingPages[path].seo.title;
        } else if (path.startsWith('/bicicletas/') && bikeCollections.find(c => `/bicicletas/${c.slug}` === path)) {
            title = bikeCollections.find(c => `/bicicletas/${c.slug}` === path).title;
        } else if (seo.pages[path]) {
            title = seo.pages[path].title; // Same titles as the static pages built by scripts/inject-metadata.js
        } else if (path.startsWith('/accesorios')) {
            title = 'Accesorios | PROOMTB & ROAD';
        } else if (path.startsWith('/ebikes')) {
            title = 'E-Bikes | PROOMTB & ROAD';
        } else if (path.startsWith('/admin')) {
            if (path.includes('/bikes')) title = 'Admin - Bicicletas | PROOMTB';
            else if (path.includes('/accessories')) title = 'Admin - Accesorios | PROOMTB';
            else if (path.includes('/dashboard')) title = 'Admin - Dashboard | PROOMTB';
            else title = 'Admin Panel | PROOMTB';
        } else if (path.startsWith('/series/')) {
            // Extract series name and format it
            const seriesSegments = path.split('/');
            const seriesName = seriesSegments[seriesSegments.length - 1]; // Get last segment
            const formattedName = seriesName.split('-').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
            title = `Raymon ${formattedName}: modelos y precios | PROOMTB & ROAD`;
        } else if (path.startsWith('/profile')) {
            title = 'Mi Perfil | PROOMTB';
        }

        document.title = title;
    }, [location]);

    return null;
};

export default PageTitleUpdater;
